import { Button, Typography } from '@packages/ui/shared';
import { Modal } from 'react-bootstrap';

/**
 * Props for the DeleteCaseModal component.
 */
export type DeleteCaseModalProps = {
    /** Whether a delete operation is currently in progress. */
    isDeleting: boolean;

    /** Whether the modal is visible. */
    isVisible: boolean;

    /** Callback to dismiss the modal. */
    onClose: () => void;

    /** Callback to confirm and delete the draft case. */
    onConfirm: () => void;
};

/**
 * Confirmation modal shown before deleting a draft Techline case.
 * Warns the user that the action cannot be undone.
 *
 * @param props - component props
 * @returns the delete case confirmation modal
 */
export function DeleteCaseModal({ isDeleting, isVisible, onClose, onConfirm }: DeleteCaseModalProps) {
    // Forwarded callback aliases
    const handleClose = onClose;
    const handleConfirmButtonPress = onConfirm;

    return (
        <Modal centered={true} onHide={handleClose} show={isVisible}>
            <Modal.Header>
                <Modal.Title>Delete Draft Case</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Typography>Are you sure you want to delete this draft case? This action cannot be undone.</Typography>
            </Modal.Body>
            <Modal.Footer>
                <div className="mr-2">
                    <Button disabled={isDeleting} onPress={handleClose} variant="ghost-blue">
                        Cancel
                    </Button>
                </div>
                <Button
                    disabled={isDeleting}
                    isLoading={isDeleting}
                    onPress={handleConfirmButtonPress}
                    variant="danger"
                >
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
